import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    // Ленивая загрузка главной страницы для улучшения начальной производительности
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },
  {
    path: "/bodygraph",
    name: "BodyGraph",
    // Очень тяжелый компонент с графиками - ленивая загрузка
    component: () =>
      import(/* webpackChunkName: "bodygraph" */ "../views/BodyGraph.vue")
  },
  {
    path: "/composite",
    name: "Composite",
    // Тяжелый компонент с композитными графиками - ленивая загрузка
    component: () =>
      import(
        /* webpackChunkName: "composite" */
        "../views/BodyGraphComposite.vue"
      )
  },
  {
    path: "/transit",
    name: "Transit",
    // Тяжелый компонент с транзитами - ленивая загрузка
    component: () =>
      import(/* webpackChunkName: "transit" */ "../views/BodyGraphTransit.vue")
  },
  {
    path: "/returns",
    name: "Returns",
    // Тяжелый компонент с возвратами - ленивая загрузка
    component: () =>
      import(/* webpackChunkName: "returns" */ "../views/Returns.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Profile.vue")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/Settings.vue")
  },
  {
    path: "/books",
    name: "Books",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Books.vue")
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Products.vue")
  },
  {
    path: "/consultations",
    name: "Consultations",
    component: () => import("../views/Consultations.vue")
  },
  {
    path: "/feed",
    name: "Feed",
    component: () => import("../views/Feed.vue")
  },
  {
    path: "/chats",
    name: "Chats",
    // Тяжелый компонент с большим количеством чатов - ленивая загрузка
    component: () =>
      import(/* webpackChunkName: "chats" */ "../views/Chats.vue")
  },
  {
    path: "/dating",
    name: "Dating",
    // Тяжелый компонент с большим количеством функций - ленивая загрузка
    component: () =>
      import(/* webpackChunkName: "dating" */ "../views/Dating.vue")
  },
  {
    path: "/socialprofile",
    name: "SocialProfile",
    component: () => import("../views/SocialProfile.vue")
  },
  {
    path: "/post",
    name: "Post",
    component: () => import("../components/community/posts/post.vue")
  },
  {
    path: "/reset",
    name: "Reset password",
    component: () => import("../views/Reset.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
